export enum CkmSetupStepsEnum {
    QUESTIONNAIRE_RETEST = 0,
    REACTIONS = 1,
    ORDER_DETAILS = 2,
}
